import { render, staticRenderFns } from "./KPageContainer.vue?vue&type=template&id=2bd4ad38&scoped=true"
import script from "./KPageContainer.vue?vue&type=script&lang=js"
export * from "./KPageContainer.vue?vue&type=script&lang=js"
import style0 from "./KPageContainer.vue?vue&type=style&index=0&id=2bd4ad38&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2bd4ad38",
  null
  
)

export default component.exports